<template>
	<v-row justify="center">
		<v-col cols="12" md="6" lg="4" xl="3">
			<v-card class="mb-16">
				<v-card-text class="px-8">
					<h2 class="display-2 black--text mb-6 py-4">Reset password</h2>
					<v-text-field
						label="Email"
						v-model="email"
						type="email"
						outlined
						dense
					></v-text-field>
					<v-text-field
						label="New password"
						v-model="password"
						type="password"
						outlined
						dense
					></v-text-field>
					<v-text-field
						label="Confirm password"
						v-model="passwordConfirmation"
						type="password"
						outlined
						dense
					></v-text-field>
					<v-btn :loading="loading" block color="primary" class="mb-4" @click="submit">
						Reset password
					</v-btn>
					<v-btn text block :to="__authPath">Back to sign in</v-btn>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>
</template>
<script>
import Main from "../../../mixins/Main";

export default {
	name: 'ResetPassword',
	mixins: [Main],
	data() {
		return {
			email: this.$route.query.email || '',
			token: this.$route.query.token || '',
			password: '',
			passwordConfirmation: '',
			loading: false,
		}
	},
	methods: {
		submit() {
			if (!this.token || !this.email) {
				this.__error('This reset link is missing a token.');
				return;
			}
			if (this.password.length < 8) {
				this.__error('Password must be at least 8 characters.');
				return;
			}
			if (this.password !== this.passwordConfirmation) {
				this.__error('Password confirmation does not match.');
				return;
			}
			this.loading = true;
			axios.post(this.__authApiPath + 'password/reset/token', {
				token: this.token,
				email: this.email,
				password: this.password,
				password_confirmation: this.passwordConfirmation,
			})
				.then(response => {
					this.__info(response.data.message);
					this.$router.push(this.__authPath);
				})
				.catch(error => this.__errorResponse(error))
				.finally(() => this.loading = false);
		},
	},
}
</script>
